import React from 'react';
export function Footer() {
  return <footer className="bg-[#0A1F33] text-white/70 py-16 px-4 sm:px-6 lg:px-8 border-t border-white/10" data-id="element-252" data-mp="32wd2cf6gdjt0">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8" data-id="element-253" data-mp="3ggk8mvu5ve02">
        {/* Column 1 */}
        <div className="lg:pr-8" data-id="element-254" data-mp="36pfutzg81z6t">
          <img src="https://cdn.magicpatterns.com/uploads/vBy52qowPNFNY53vkUADE7/SyNeural-logo-no-tagline-half-size.svg" alt="SyNeural" className="h-10 w-auto mb-5 brightness-0 invert" data-id="element-255" data-mp="36qhhl16loa4d" />
          <p className="text-sm leading-relaxed" data-id="element-256" data-mp="37xvkgeim0i0">
            Building intelligence in the world.
          </p>
        </div>

        {/* Column 2 */}
        <div data-id="element-257" data-mp="3qcx8kbgauo39">
          <h4 className="text-white font-heading font-bold mb-6 uppercase tracking-wider text-sm" data-id="element-258" data-mp="3qcdu54puyhtz">
            Products
          </h4>
          <ul className="space-y-3 text-sm" data-id="element-259" data-mp="2a19tpmiidoxa">
            <li data-id="element-260" data-mp="2eyt8qon165qa">
              <a href="/human-capability" className="hover:text-white transition-colors" data-id="element-261" data-mp="2ezb9nykn184j">
                Human Capability Platform
              </a>
            </li>
            <li data-id="element-262" data-mp="3gc0ftfnsvm5i">
              <a href="/cji" className="hover:text-white transition-colors pl-3" data-id="element-263" data-mp="3gcaa3ffvofh0">
                CJI
              </a>
            </li>
            <li data-id="element-264" data-mp="3q8wq9qx9eicp">
              <a href="/ncji" className="hover:text-white transition-colors pl-3" data-id="element-265" data-mp="3q8dih31bpace">
                NCJI
              </a>
            </li>
            <li data-id="element-266" data-mp="817cu4ckvmt0">
              <a href="/semantic-knowledge" className="hover:text-white transition-colors" data-id="element-267" data-mp="80nrsermsiar">
                Semantic Knowledge Platform
              </a>
            </li>
            <li data-id="element-268" data-mp="cu0fmmohkl2g">
              <a href="/llm-vs-skp" className="hover:text-white transition-colors pl-3" data-id="element-269" data-mp="ctgwx3r0hsnd">
                LLM vs. SKP
              </a>
            </li>
            <li data-id="element-270" data-mp="qrfai6xidl1t">
              <a href="/solutions" className="hover:text-white transition-colors" data-id="element-271" data-mp="mrwplb5ot9yz">
                Solutions
              </a>
            </li>

          </ul>
        </div>

        {/* Column 3 */}
        <div data-id="element-272" data-mp="yv93jr68lwup">
          <h4 className="text-white font-heading font-bold mb-6 uppercase tracking-wider text-sm" data-id="element-273" data-mp="yupkg74up2f3">
            Applications
          </h4>
          <ul className="space-y-3 text-sm" data-id="element-274" data-mp="18k0qfkwfxqyr">
            <li data-id="element-275" data-mp="18l2c0jb31vuq">
              <a href="/education" className="hover:text-white transition-colors" data-id="element-276" data-mp="18lkbdot1kq6v">
                Education
              </a>
            </li>
            <li data-id="element-277" data-mp="1hje64vb5rbrx">
              <a href="/employers" className="hover:text-white transition-colors" data-id="element-278" data-mp="1hiumna5v0fbs">
                Employers
              </a>
            </li>
            <li data-id="element-279" data-mp="1rid49jyarp0o">
              <a href="/civil-society" className="hover:text-white transition-colors" data-id="element-280" data-mp="1rgsfyc2kt2b9">
                Civil Society
              </a>
            </li>
            <li data-id="element-281" data-mp="3tccdlzruzwaq">
              <a href="/government" className="hover:text-white transition-colors" data-id="element-282" data-mp="2af3sdp3431j3">
                Government
              </a>
            </li>
            <li data-id="element-283" data-mp="25mkh4yrwcihg">
              <a href="/leadership" className="hover:text-white transition-colors" data-id="element-284" data-mp="21mjy10turj42">
                Leadership
              </a>
            </li>
          </ul>
        </div>

        {/* Column 4 */}
        <div data-id="element-285" data-mp="2tdg3hgdl2lhb">
          <h4 className="text-white font-heading font-bold mb-6 uppercase tracking-wider text-sm" data-id="element-286" data-mp="2tbvjgkowakxp">
            Company
          </h4>
          <ul className="space-y-3 text-sm" data-id="element-287" data-mp="2kd1gmckz0ybp">
            <li data-id="element-288" data-mp="2kbqai641zehf">
              <a href="/about" className="hover:text-white transition-colors" data-id="element-289" data-mp="2kfe5zat26ays">
                About
              </a>
            </li>
            <li data-id="element-290" data-mp="18xuz98g9rpvh">
              <a href="/research" className="hover:text-white transition-colors" data-id="element-291" data-mp="18yedae2stu48">
                Research
              </a>
            </li>
            <li data-id="element-292" data-mp="2rv7nvttzprz7">
              <a href="/roadmap" className="hover:text-white transition-colors" data-id="element-293" data-mp="2ruogv85vonzy">
                Roadmap
              </a>
            </li>
            <li data-id="element-294" data-mp="2ivud8xu4qxcw">
              <a href="/partnerships" className="hover:text-white transition-colors" data-id="element-295" data-mp="2iwciul2omnxh">
                Partnerships
              </a>
            </li>
            <li data-id="element-296" data-mp="3bkrx35dzp27r">
              <a href="/investors" className="hover:text-white transition-colors" data-id="element-297" data-mp="3bk8c1ft1lxpi">
                Investors
              </a>
            </li>
            <li data-id="element-298" data-mp="31lsx0b7aiewd">
              <a href="/contact" className="hover:text-white transition-colors" data-id="element-299" data-mp="31m2fldq09js1">
                Contact
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto mt-16 pt-8 border-t border-white/10 text-xs flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-300" data-mp="1q6druk4xggq6">
        <p data-id="element-301" data-mp="1v69t4bm8pu21">&copy; {new Date().getFullYear()} SyNeural. All rights reserved.</p>
        <div className="flex gap-6" data-id="element-302" data-mp="1nl69by039ln5">
          <a href="/privacy" className="hover:text-white transition-colors" data-id="element-303" data-mp="1nk4nqzlg5gr6">
            Privacy Policy
          </a>
          <a href="/terms" className="hover:text-white transition-colors" data-id="element-304" data-mp="1ip7d5o8iqzc6">
            Terms of Service
          </a>
        </div>
      </div>
    </footer>;
}